module.exports = __webpack_public_path__ + "static/media/corner_white.17759438.svg";